import React from "react";
import * as PropTypes from "prop-types";

const PaperclipSVG = ({ classProp = "" }) => (
  <svg
    aria-hidden="true"
    className={`PaperclipSVG ${classProp}`}
    fill="none"
    focusable="false"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeWidth="1.5"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10.4 4.2 5.1 9.5a1.7 1.7 0 0 0 2.4 2.4l5.3-5.3a3.4 3.4 0 0 0-4.8-4.8L2.7 7.1a5.1 5.1 0 0 0 7.2 7.2l3.4-3.4" />
  </svg>
);

PaperclipSVG.propTypes = {
  classProp: PropTypes.string,
};

export default PaperclipSVG;
